import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber matemáticas o astrología avanzada?',
  a: 'No, el sistema está diseñado para que cualquier persona obtenga su perfil con datos básicos.'
}, {
  q: '¿Cuánto tiempo me toma hacerlo?',
  a: 'Puedes tener tu perfil básico listo en menos de 15 minutos.'
}, {
  q: '¿Es un informe que generas tú?',
  a: 'No, es una guía de autodescubrimiento para que TÚ aprendas a leer tus propias energías.'
}, {
  q: '¿Funciona para parejas y familia?',
  a: 'Absolutamente, entender el Perfil Trino de otro es la clave de la armonía.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-22">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 className="text-3xl sm:text-4xl font-bold font-serif text-trino-burgundy mb-4" data-id="element-25">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-trino-gold mx-auto rounded-full" data-id="element-26"></div>
        </div>

        <div className="space-y-4" data-id="element-27">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-trino-peach/50 rounded-xl overflow-hidden bg-trino-cream/30" data-id="element-28">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-29">
                <span className="font-bold text-trino-dark text-lg pr-4" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-trino-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>
              <AnimatePresence data-id="element-32">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-6 pb-5 text-trino-dark/70 leading-relaxed" data-id="element-34">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}